import { render, staticRenderFns } from "./premiumAdd.vue?vue&type=template&id=9d10a88e&scoped=true&"
import script from "./premiumAdd.vue?vue&type=script&lang=js&"
export * from "./premiumAdd.vue?vue&type=script&lang=js&"
import style0 from "./premiumAdd.vue?vue&type=style&index=0&id=9d10a88e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d10a88e",
  null
  
)

export default component.exports